import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import { FolderForestTreeType, FolderForestNodeType } from 'owa-favorites-types';
import { Folder } from 'owa-folders';
import { action, select } from 'satcheljs/lib/legacy';
import { default as viewStateStore } from '../store/store';
import FolderTreeViewStateStore from '../store/schema/FolderTreeViewStateStore';

export interface FolderTreeContextMenuState {
    folderTreeViewState?: FolderTreeViewStateStore;
}

/*
 * Sets state to spawn a context menu attached to a MailFolderList folder.
 */
export let showFolderTreeContextMenu = select<FolderTreeContextMenuState>({
    folderTreeViewState: () => viewStateStore,
})(
    action('showFolderTreeContextMenu')(function (
        nodeId: string,
        nodeType: FolderForestNodeType,
        folder: Folder,
        anchor: IPoint,
        treeType: FolderForestTreeType,
        state?: FolderTreeContextMenuState
    ): void {
        // VSO 13261: Refactor the showHideContextMenu to only takes in the folderId
        state.folderTreeViewState.withContextMenuFolderId = folder.FolderId.Id;
        state.folderTreeViewState.contextMenuState = {
            nodeId,
            nodeType,
            folder,
            anchor,
            treeType,
        };
    })
);

/*
 * Sets state to close the context menu attached to a MailFolderList folder.
 */
export let hideFolderTreeContextMenu = select<FolderTreeContextMenuState>({
    folderTreeViewState: () => viewStateStore,
})(
    action('hideFolderTreeContextMenu')(function (state?: FolderTreeContextMenuState): void {
        state.folderTreeViewState.withContextMenuFolderId = null;
        state.folderTreeViewState.contextMenuState = null;
    })
);
